<template>
  <div>
    <home-header
      titulo="Tabela de Coparticipação"
      texto1="
        Para saber o valor a pagar pelos procedimentos realizados, escolha
        abaixo o seu Plano         
     "
      :hasShowTable="true"
    />
    <planos-buttons :isShowButtonUFSC="tipopessoa === 'pj'" />
    <faq-coparticipacao />
    <div class="mensagem-rodape">
      Para saber mais detalhes sobre cobrança de coparticipação,
      <strong> entre em contato com a sua empresa! </strong>
    </div>
  </div>
</template>

<script>
import Header from "../components/header/Header";
import Planos from "../components/planos/Planos";
import Faq from "../components/faq/Faq";

export default {
  props: {
    tipopessoa: {
      type: String,
      default: "pf",
    },
  },
  components: {
    "home-header": Header,
    "planos-buttons": Planos,
    "faq-coparticipacao": Faq,
  },
  created() {
    this.$store
      .dispatch("autenticar")
      .then(() => this.$router.push({ name: "Tabelas" }));
  },
};
</script>

<style scoped>
.card-pesquisa {
  display: flex;
  height: 200px;
  background-color: #439763;
}

.mensagem-rodape {
  text-align: center;
  padding: 50px 0 80px;
}
</style>
